/**
 * Decorative outcome-image parameters. All geometry/opacity is data so the
 * `/workspace/outcome-image-tuner` route can render the REAL card with a live
 * `decorOverride` and porting is a 1:1 value copy back into
 * {@link DEFAULT_OUTCOME_DECOR}. Opacities are 0–100; positions/sizes are %.
 */
export interface OutcomeDecorParams {
  imgX: number;
  imgY: number;
  imgSize: number;
  imgRadius: number;
  /** 0 = hard edge, 100 = fully feathered from the centre. */
  edgeFade: number;
  blur: number;
  opLight: number;
  opDark: number;
  tintOpLight: number;
  tintOpDark: number;
  tintSpread: number;
  tintFx: number;
  tintFy: number;
  tintTransparent: number;
}

// Dialled in via /workspace/outcome-image-tuner — keep in sync with that route.
export const DEFAULT_OUTCOME_DECOR: OutcomeDecorParams = {
  imgX: 87,
  imgY: 16,
  imgSize: 58,
  imgRadius: 0,
  edgeFade: 100,
  blur: 0.5,
  opLight: 26,
  opDark: 14,
  tintOpLight: 15,
  tintOpDark: 15,
  tintSpread: 142,
  tintFx: 96,
  tintFy: 0,
  tintTransparent: 50,
};
